import type { JSX } from 'react';
import React from 'react';

import { Pill, Text } from '@feathr/components';

interface IMetaLookalikeValueProps {
  isReport: boolean;
  metaLookalikeLabel?: string;
  reachedMetaLookalike: string;
  targetedMetaLookalike: string;
}

function MetaLookalikeValue({
  isReport,
  metaLookalikeLabel,
  reachedMetaLookalike,
  targetedMetaLookalike,
}: Readonly<IMetaLookalikeValueProps>): JSX.Element {
  if (isReport) {
    return (
      <Text.DefaultSemibold inline={true}>
        {reachedMetaLookalike}
        <Text.DefaultRegular inline={true}> / {targetedMetaLookalike}</Text.DefaultRegular>
      </Text.DefaultSemibold>
    );
  }

  if (metaLookalikeLabel) {
    return (
      <Pill showPrefix={false} theme={'blue'} variant={'primary'}>
        {metaLookalikeLabel}
      </Pill>
    );
  }

  return <Text.DefaultSemibold>~{targetedMetaLookalike}</Text.DefaultSemibold>;
}

export default MetaLookalikeValue;
